class GenderValidation {
  /**
   * Validate that gender sum equals participants total
   * @param {HTMLElement} container Containing element with .js-gender-validation class
   */
  constructor (container) {
    this.container = container
    this.formSubmitButton = document.querySelector('#license-submit')

    /** @type {HTMLInputElement} */
    this.participantsInput = container.querySelector('.js-participants-total')

    /** @type {NodeListOf<HTMLInputElement>} */
    this.genderInputs = container.querySelectorAll('.js-gender-input')

    /** @type {HTMLElement} */
    this.errorNotification = container.querySelector('.js-gender-sum-error')

    /** @type {HTMLFormElement} */
    this.form = document.querySelector('form.form')
  }

  init () {
    if (!this.participantsInput || !this.genderInputs.length) {
      return
    }

    this.participantsInput.addEventListener('input', () => this.validate())

    this.genderInputs.forEach(input => {
      input.addEventListener('input', () => this.validate())
    })

    if (this.form) {
      this.form.addEventListener('submit', (e) => this.onSubmit(e))
    }

    // Run initial validation
    this.validate()
  }

  get participantsValue () {
    return parseInt(this.participantsInput.value) || 0
  }

  get genderSum () {
    let sum = 0
    this.genderInputs.forEach(input => {
      sum += parseInt(input.value) || 0
    })
    return sum
  }

  get hasGenderValues () {
    return Array.from(this.genderInputs).some(input => input.value !== '')
  }

  get allGenderFieldsFilled () {
    return Array.from(this.genderInputs).every(input => input.value !== '')
  }

  validate () {
    const participants = this.participantsValue
    const genderSum = this.genderSum
    const hasParticipants = this.participantsInput.value !== ''

    // If participants is filled, gender fields must also be filled and sum must match
    if (hasParticipants) {
      // Show error if at least one gender field has a value and sum doesn't match
      if (this.hasGenderValues && genderSum !== participants) {
        this.showError()
        this.disableSubmitButton()
        return false
      }

      // Disable submit if not all gender fields are filled (but don't show error yet)
      if (!this.allGenderFieldsFilled) {
        this.hideError()
        this.disableSubmitButton()
        return false
      }
    }

    // All good - hide error and enable submit
    this.hideError()
    this.enableSubmitButton()
    return true
  }

  onSubmit (e) {
    const participants = this.participantsValue
    const genderSum = this.genderSum

    // Block submit if gender fields are incomplete or sum doesn't match
    if (!this.allGenderFieldsFilled || genderSum !== participants) {
      e.preventDefault()
      this.showError()
      if (this.errorNotification) {
        this.errorNotification.scrollIntoView({ behavior: 'smooth', block: 'center' })
      }
      return false
    }
  }

  showError () {
    if (this.errorNotification) {
      this.errorNotification.hidden = false
    }
  }

  hideError () {
    if (this.errorNotification) {
      this.errorNotification.hidden = true
    }
  }

  enableSubmitButton () {
    const validationErrors = document.querySelectorAll('.notification--error:not([hidden])')
    if (validationErrors.length) {
      return
    }

    if (this.formSubmitButton) {
      this.formSubmitButton.ariaDisabled = 'false'
      this.formSubmitButton.removeAttribute('disabled')
    }
  }

  disableSubmitButton () {
    if (this.formSubmitButton) {
      this.formSubmitButton.ariaDisabled = 'true'
      this.formSubmitButton.setAttribute('disabled', '')
    }
  }
}

const containers = document.querySelectorAll('.js-gender-validation')
containers.forEach(container => new GenderValidation(container).init())
